import { useCatalogsStore } from "stores/catalogs";
import { RootState } from "../store";

export const all = (state: RootState) => state.userReducer;

export const balance = (state: RootState) => all(state).balance;
export const bonus = (state: RootState) => all(state).bonus;
export const bonuses = (state: RootState) => all(state).bonuses;
export const canceledBonus = (state: RootState) => all(state).canceledBonus;
export const freeSpins = (state: RootState) => all(state).freeSpins;
export const currency = (state: RootState) => {
  const { currencies } = useCatalogsStore.getState();
  return currencies?.find((c) => c.isoCode === all(state).currency) || null;
};
export const currentCurrency = (state: RootState) => all(state).currency;
export const id = (state: RootState) => all(state).id;
export const login = (state: RootState) => all(state).login;
export const isBanned = (state: RootState) => all(state).isBanned;
export const emailRecovery = (state: RootState) => all(state).emailRecovery;
export const sumDeposit = (state: RootState) => all(state).sumDeposit;
export const sumBet = (state: RootState) => all(state).sumBet;
export const welcomeExtraBonusExpire = (state: RootState) =>
  all(state).welcomeExtraBonusExpire;
export const referrerBalance = (state: RootState) => all(state).referrerBalance;
export const countDeposit = (state: RootState) => all(state).countDeposit;
